(function () {
    "use strict";

    // NOTICE: When instantiating a habil-kbo-field, only add required=true when really required
    angular.module("app").directive("habilKboField", HabilKboFieldDirective);

    HabilKboFieldDirective.$inject = [];
    function HabilKboFieldDirective() {
        return {
            templateUrl: "@/textField/kbo-field.html",
            transclude: true,
            require: { ngModelCtrl: "^ngModel", ngFormCtrl: "^form" },
            scope: {
                required: "=?",
                isReadonly: "=",
                onValidKboEntered: "=?",
                onInvalidated: "=?",
            },
            link: link
        };

        function link(scope, _element, _attributes, ctrl) {
            // The NgModelController used for hooking into the angular model and form
            const ngModelCtrl = ctrl.ngModelCtrl;
            const ngForm = ctrl.ngFormCtrl;

            scope.form = ngForm;

            // #region Value handler

            ngModelCtrl.$render = () => {
                scope.ngModel = ngModelCtrl.$viewValue;
            };

            // External changes
            scope.$watch(function () { return scope.ngModel; }, function (newValue, oldValue) {
                // Only set the view value and invoke the callback if a new value is set, otherwise the callback is invoked on load
                if (newValue != oldValue) {
                    ngModelCtrl.$setViewValue(newValue);

                    if (ngModelCtrl.$valid) {
                        invokeCallback();
                    }
                    else {
                        invokeInvalidatedCallback();
                    }
                }
            });

            // #endregion

            function invokeCallback() {
                if (angular.isFunction(scope.onValidKboEntered))
                    scope.onValidKboEntered(scope.ngModel);
            }

            function invokeInvalidatedCallback() {
                if (angular.isFunction(scope.onInvalidated))
                    scope.onInvalidated();
            }
        }
    }
})();